export interface IOptions {
  name: string;
  _id: string;
}
